export default {
  getSyslog: {
    method: 'get',
    url: 'syslog'
  }
}
